/* eslint-disable react/jsx-props-no-spreading */
import { format, isValid } from 'date-fns';
import React from 'react';

import InputFieldDate from '@/components/InputFieldDate';
import InputFieldTime from '@/components/InputFieldTime';

import { ArtifactFieldWidget } from '../components/ArtifactForm/ArtifactForm.types';

export const AgendamentoDateWidget: ArtifactFieldWidget = ({
  control: { field, fieldState },
  field: formField,
  fieldState: artifactFieldState,
}) => {
  const dateValue = typeof field.value === 'string' ? field.value : '';

  return (
    <InputFieldDate
      name={formField.name}
      title={artifactFieldState.label}
      value={dateValue}
      disabled={artifactFieldState.disabled}
      readOnly={formField.readOnly}
      error={fieldState.error?.message}
      onChangeDate={date => {
        if (!date || !isValid(date)) {
          field.onChange('');
          return;
        }

        field.onChange(format(date, 'yyyy-MM-dd'));
      }}
    />
  );
};

export const AgendamentoTimeWidget: ArtifactFieldWidget = ({
  control: { field, fieldState },
  field: formField,
  fieldState: artifactFieldState,
}) => {
  const timeValue = typeof field.value === 'string' ? field.value : '';

  return (
    <InputFieldTime
      name={formField.name}
      title={artifactFieldState.label}
      value={timeValue}
      disabled={artifactFieldState.disabled}
      readOnly={formField.readOnly}
      error={fieldState.error?.message}
      onChangeTime={value => field.onChange(value || '')}
    />
  );
};
